import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import './plugins'
import store from './store'
import 'leaflet/dist/leaflet.css'
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import VueAnimateOnScroll from 'vue-animate-onscroll'
import smoothscroll from 'smoothscroll-polyfill'

Vue.component('l-map', LMap)
Vue.component('l-tile-layer', LTileLayer)
Vue.component('l-marker', LMarker)

Vue.config.productionTip = false

if (typeof window !== 'undefined') {
  smoothscroll.polyfill()
}
Vue.use(VueAnimateOnScroll)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
